<template>
  <div class="middle-box text-center loginscreen">
    <div>
       <div>Git Describe: {{gitVersion}}</div>
       <div>Git Branch Name: {{branckName}}</div>
       <div>Build Date: {{buildDate}}</div>
       <div>Version Number:{{version}}</div>
    </div>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";
export default {
  mixins: [config.globalMixin],
  name: "versionController",
  data() {
    return {
      version:"",
      branckName:"",
      gitVersion:"",
      buildDate:"",
      commitHash:""
    };
  },
  created: function() {
    var date = new Date();
    this.year = date.getFullYear();
  },
  methods: {
    async login(e) {
      e.preventDefault();
      let setLogin = this.setFormData({
        userName: this.username,
        password: this.password,
        lang:"en_US",
      });
      try {
        let data = await this.$store.dispatch("login", setLogin);
        if (data) {
          this.$router.push({ path: "/main/homePage" });
        }
      } catch (err) {
        this.$store.commit("setwarning", {
          string: "Network Error.",
          boolean: true,
          button: [{
            name:this.$i18n.t("message.Confirm"),
            callBack:function(){}
          }]
        });
      }
    },
    assembleFunction: function(parentObj, list) {
      for (var i = 0; i < list.length; i++) {
        var childObj = list[i];
        if (parentObj.id == childObj.parentId) {
          if (parentObj.children) {
            parentObj.children.push(childObj);
          } else {
            parentObj.children = [];
            parentObj.children.push(childObj);
          }
          assembleFunction(childObj, list);
        }
      }
    }
  },
  mounted() {
    this.version = process.env.PACKAGE_VERSION;
    this.gitVersion = process.env.VERSION;
    this.branckName = process.env.BRANCH;
    this.buildDate = process.env.DATE;
    this.commitHash = process.env.COMMITHASH;
    eventBus.$on(
      "warningBtn",
      function(name) {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: []
        });
      }.bind(this)
    );
  }
};
</script>

<style scoped>
</style>

